/**
 *
 * App
 *
 */

import React, { useContext } from 'react';
import { connect } from 'react-redux';
import Route from '../../containers/Route/Loadable';
import GlobalStyle from '../../global-styles';
import ApiManager from '../../ApiManager/ApiManager';
import { Manager } from '../../StorageManager/Storage';
import {
    setSession,
    loginUserSuccess,
    changeLoading,
} from '../../redux/auth/actions';
import { Grid, Typography } from '@material-ui/core';
import { useStyles } from './styles.js';
import { Sentry } from 'react-activity';
import "react-activity/dist/library.css";
import SocketManager, { GPSinaSocketListners } from '../../SocketManager/SocketManager';
import Config from '../../constants/config';
import GPSinaApis from '../../ApiManager/GPSinaApis';
import { ColorSchemeContext } from '../../Theme/ColorScheme';


function App(props) {
    let api = ApiManager.getInstance();

    const classes = useStyles(props);
    const { activeColorScheme,setColorByAppType }= useContext(ColorSchemeContext)

    const connectSocket = (user, token, sessionId) => {
        let socket = SocketManager.getInstance();
        socket.addListeners(GPSinaSocketListners.Connect, (data) => {
            api.setSession(sessionId);
            props.dispatch(setSession(sessionId));
            props.dispatch(changeLoading(false));
            api.setToken(user._id, token);
            props.dispatch(
                loginUserSuccess(token, user),
            );
        })
        socket.connect(user._id, token, () => null, () => null, () => null, () => null, () => null, () => null, () => null, () => null, () => null)
    }

    React.useEffect(() => {
        let newAppType = Config.appType
        setColorByAppType(newAppType)

    }, []);

    React.useEffect(() => {
        if (!props.loading) return;
        Manager.getItem('sessionId', true)
            .then(sessionId => {
                if (sessionId != null && sessionId != '') {
                    if (props.token === null) {
                        Manager.getItem('token', true)
                            .then(token => {
                                if (token !== null && token !== '') {
                                    Manager.getItem('user', true)
                                        .then(user => {
                                            if (user !== null && user !== '') {
                                                connectSocket(user, token, sessionId);
                                            }
                                        })
                                        .catch(error => console.log(error));
                                } else {
                                    api.setSession(sessionId);
                                    props.dispatch(setSession(sessionId));
                                    props.dispatch(changeLoading(false));
                                }
                            })
                            .catch(error => console.log(error));
                    }
                    // api.send('POST', '/updateSession', {
                    //     fcmKey: '123',
                    //     sessionId: sessionId,
                    // })
                    //     .then(response => {
                    //         if (response.data.code === 1014) {
                    //             api.setSession(sessionId);
                    //             props.dispatch(setSession(sessionId));
                    //             props.dispatch(changeLoading(false));
                    //         }
                    //     })
                    //     .catch(error =>
                    //         console.log('session create error: ', error),
                    //     );
                } else {
                    const body = {
                        fcmKey: '123',
                        appID: Config.appType,
                        version: Config.appVersion,
                        platform: 'web'
                    }
                    GPSinaApis.createSession(body).then((response) => {
                        if (response) {
                            console.log("what is create  session api response: ", response);
                            api.setSession(response.sessionId);
                            props.dispatch(setSession(response.sessionId));
                            props.dispatch(changeLoading(false));
                            Manager.setItem('sessionId', response.sessionId);
                        }
                    }).catch(err => console.log(err));
                }
            })
            .catch(error => console.log('session create error: ', error));
    }, [props.loading]);

    return props.loading ? (
        <Grid
            container
            justifyContent="center"
            className={classes.loading}
        >
            <Grid item xs={3}>
                <Grid className={classes.activity}>
                    <Sentry
                        color="#28ACEA"
                        size={200}
                        speed={1}
                        animating={true}
                    />
                </Grid>
            </Grid>
        </Grid>
    ) : (
        <>
            <Route />
            <GlobalStyle />
        </>
    );
}

const mapStateToProps = ({ auth }) => {
    return auth;
};
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(App);
